module.exports = __webpack_public_path__ + "img/img-3.3a7d53ed.png";